import styled from "styled-components";

export const BannerContainer = styled.div.attrs({})`
  position: relative;
  width: 136px;
  background: url(${props => props.bgImage}) center/cover no-repeat;
  display: flex;
  align-items: center;
  transition: background-image 0.8s ease-in-out;
  @media(max-width: 560px){
    width: 100%;
    height: 136px;
  }
`;

export const Container = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 24px;

`;

export const Content = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const Title = styled.div.attrs({})`
  color: ${p => p.theme.palette.colors.black};
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;

`;

export const TitleContent = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0px 16px 16px 16px;
`;

export const OptionsIcon = styled.div.attrs({})`
  padding: 7px 6px;
  background: ${p => p.theme.palette.colors.lightBlue};
  border-radius: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
`;


export const AudioHeader = styled.div.attrs({})`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
`;

export const AudioContent = styled.div.attrs({})`
  background: ${p => p.theme.palette.blue.main};
  flex: 1;
  padding: 24px 16px;
`;

export const AudioTitle = styled.div.attrs({})`
  color: ${p => p.theme.palette.colors.white};
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  flex:1;
  @media(max-width: 460px){
    font-size: 16px;
  }
`;

export const ProgressBarContainer = styled.div`
  height: 4px;
  background-color: #fff;
  margin-bottom: 8px;
  width: 100%;
`;

export const Progress = styled.div`
  width: 42%;
  height: 100%;
  background-color: #ccc;
`;

export const TimeDisplay = styled.div.attrs({})`
  display: flex;
  font-size: 14px;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  color: ${p => p.theme.palette.colors.white};
`;

export const Controls = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 24px;
  justify-content: space-between;
`;
export const ControlsContainer = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 24px;
`;
